

import { useQuery } from "react-query"; // 
import { JobResponse } from "../../../../models/Job";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";


export async function fetchAllJob(data: {
    search: string;
    lokasi: string;
    divisi: string;
}): Promise<JobResponse[]> {
    const res = await ApiClient.get(
        `/AllJob?search=${data.search}&lokasi=${data.lokasi}&divisi=${data.divisi}`
    );
    return res.data;
}

export function useFetchAllJobQuery(
    params: { search: string; lokasi: string; divisi: string },
    options?: object
) {
    return useQuery(
        ['all-jobs-key', params],
        () => fetchAllJob(params),
        { ...options }
    );
}
